// Pincode data organized by city
export const pincodesByCity = {
  gurgaon: [
    '122001',
    '122002',
    '122003',
    '122004',
    '122005',
    '122006',
    '122007',
    '122008',
    '122009',
    '122010',
    '122011',
    '122012',
    '122015',
    '122016',
    '122017',
    '122018',
    '122051',
    '122413',
    '122998',
    '122052',
    '122503',
    '123505',
    '122098',
    '122505',
    '122101',
    '122506'
  ]
  // You can add more cities here in the future
  // delhi: ['110001', '110002', ...],
  // noida: ['201301', '201302', ...],
};

// Helper function to check if a pincode is serviceable
export const isPincodeServiceable = (pincode) => {
  if (!pincode || pincode.length !== 6) {
    return false;
  }

  // Check in all cities
  for (const city in pincodesByCity) {
    if (pincodesByCity[city].includes(pincode)) {
      return true;
    }
  }

  return false;
};

// Helper function to get city name for a pincode
export const getCityForPincode = (pincode) => {
  if (!pincode || pincode.length !== 6) {
    return null;
  }

  for (const city in pincodesByCity) {
    if (pincodesByCity[city].includes(pincode)) {
      return city.charAt(0).toUpperCase() + city.slice(1);
    }
  }

  return null;
};

